// Hideo - what the menus opened by typing share: the "/" menu of the script page (surface/slash.ts) and the "@" menu of
// the fields and the page (src/features/mentionMenu.ts). Typed text before the cursor, the menu's place, the typed
// trigger removed when a row is picked.

/** The text before the cursor matched with `re`, when nothing is selected and the cursor is in a text node inside
 *  `root`; null otherwise */
export function typedBefore(root: Node, re: RegExp): RegExpMatchArray | null {
  const s = getSelection() as Selection
  if (!s.rangeCount || !s.isCollapsed) return null
  const n = s.anchorNode
  if (!n || n.nodeType !== 3 || !root.contains(n)) return null
  return (n.textContent as string).slice(0, s.anchorOffset).match(re)
}
/** Places a menu below the cursor (above it when there is no room below), at least `room` pixels from the right edge;
 *  fallback: the box used when the cursor has no box of its own */
export function placeAtCursor(mn: HTMLElement, fallback: (r: Range) => DOMRect, room: number): void {
  const r = (getSelection() as Selection).getRangeAt(0).cloneRange(), rc = r.getClientRects()[0] || fallback(r)
  mn.style.left = Math.max(8, Math.min(rc.left, innerWidth - room)) + 'px'
  mn.style.top = (rc.bottom + 296 > innerHeight ? Math.max(8, rc.top - 296) : rc.bottom + 6) + 'px'
}
/** Removes the trigger ("/" or "@") and the `typed` text before the cursor; returns the range where they were */
export function deleteTyped(typed: string): Range {
  const s = getSelection() as Selection, n = s.anchorNode as Node, o = s.anchorOffset, r = document.createRange()
  r.setStart(n, o - typed.length - 1); r.setEnd(n, o); r.deleteContents()
  return r
}
